export const actionTypes: any = {
  GET_FIXED_DEPOSIT_REQUESTS_START: 'GET_FIXED_DEPOSIT_REQUESTS_START',
  GET_FIXED_DEPOSIT_REQUESTS_SUCCESS: 'GET_FIXED_DEPOSIT_REQUESTS_SUCCESS',
  GET_FIXED_DEPOSIT_REQUESTS_FINISH: 'GET_FIXED_DEPOSIT_REQUESTS_FINISH',
}
